import List from 'src/storage/treatmentsList';

export class TreatmentsTimelineModel extends List {
  id = 'TreatmentsTimelineModel';
  defaultState = () => ({
    current: 'recent',
    journeyId: 'timeline',
    journeys: []
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;
  sortBy = {
    key: 'date',
    desc: true
  };
  apiConfig = {
    refresh: {
      url: 'timeline/list',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'timeline/list',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'timeline/list',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    create: {
      url: 'timeline/create',
      validation: {
        partnerId: 'userId',
        title: 'timelineTitle',
        description: 'timelineDescription',
        msgType: 'string'
      },
      cancellable: true
    },
    update: {
      url: 'timeline/update',
      validation: {
        id: 'baseId',
        title: 'timelineTitle',
        description: 'timelineDescription'
      },
      cancellable: true
    },
    remove: {
      url: 'timeline/remove',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    },

    like: {
      url: 'timeline/like',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    },

    listJourney: {
      url: 'journey/list',
      validation: {
        partnerId: 'userId'
      },
      cancellable: true
    },
    createJourney: {
      url: 'journey/create',
      validation: {
        title: 'journeyTitle',
        description: 'journeyDescription',
        files: 'journeyCover',
        icon: 'journeyIcon'
      },
      cancellable: true
    },
    removeJourney: {
      url: 'journey/remove',
      validation: {
        id: 'baseId',
        privacySettings: 'privacySettings'
      },
      cancellable: true
    },
    updatePrivacySettingsJourney: {
      url: '/journey/update/privacySettings',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleProfile',
    'foxsocket:message:timeline': 'onMessage',
    'foxsocket:message:journey': 'onJourney'
  };

  handleProfile = (profile) => {
    this.setState({ user: profile });
  };

  filterItem = (data) => {
    let journeyId = this.input('journeyId');
    if (journeyId !== 'timeline' && journeyId != data.data.journeyId) return false;
    if (!this.state.user?.isDoctor && data.from !== this.userId) return false;
    return this.onFilterOtherItem(data);
  };

  listParams(loadMore) {
    let req = {
      journeyId: this.state.journeyId !== 'timeline' ? this.state.journeyId : null,
      partnerId: 0,
      skip: 0,
      limit: this.listLimit
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }

  create = (cb) => {
    const { journey } = this.state;
    let { title, description, files } = this.getCurrent();
    let req = {
      partnerId: 0,
      title,
      description,
      files,
      msgType: 'timeline',
      journeyId: journey?.id !== 'timeline' ? journey?.id : null,
      icon: journey?.id !== 'timeline' ? journey?.icon : null
    };
    this.api('create', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (success) {
        this.resetAddTimeline();
        this.filterItem(data);
      }
    });
  };

  update = (id, cb) => {
    let { title, description, files, media } = this.getCurrent();
    let req = {
      id,
      partnerId: 0,
      title,
      description,
      files,
      media
    };

    this.api('update', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (success) {
        this.resetAddTimeline();
        this.filterItem(data);
      }
    });
  };

  like = (item, cb) => {
    let likedUserIds = [...item.likedUserIds];
    let index = likedUserIds.indexOf(this.state.user.id);
    if (index < 0) {
      item.likedUserIds.push(this.state.user.id);
    } else {
      item.likedUserIds.splice(index, 1);
    }
    this.onFilterOtherItem({
      id: item.id,
      likedUserIds: item.likedUserIds,
      likedCount: item.likedUserIds.length
    });

    let req = {
      id: item.id
    };

    this.api('like', req, (error, data, success) => {
      cb && cb(error, data, success);
      if (error) {
        this.onFilterOtherItem({ id: item.id, likedUserIds, likedCount: likedUserIds.length });
      }
    });
  };

  remove = (id, cb) => {
    let req = {
      id
    };
    this.api('remove', req, (error, data, success) => {
      if (success) {
        cb();
        this.onFilterOtherItem({ id, removedDate: Date.now() });
      }
    });
  };

  resetAddTimeline = (item, journey) => {
    this.setListState({
      icon: journey?.icon,
      files: [],
      title: item?.text || '',
      description: typeof item?.data == 'string' ? item.data : item?.data?.description,
      media: item?.media || []
    });
  };

  createJourney = (cb) => {
    let { title, description, files, icon } = this.state;
    let req = {
      title,
      description,
      icon,
      files
    };
    this.api('createJourney', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (success) {
        this.resetCreateJourney();
        this.onJourney({ channel: 'u-' + this.userId, data });
      }
    });
  };

  removeJourney = ({ id, cb }) => {
    let req = {
      id
    };
    this.api('removeJourney', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (!err) {
        this.onJourney({
          channel: 'u-' + this.userId,
          data: { id, removedDate: Date.now(), userId: this.userId }
        });
      }
    });
  };

  updatePrivacySettingsJourney = ({ id, privacySettings, cb }) => {
    let req = {
      id,
      privacySettings
    };
    this.api('updatePrivacySettingsJourney', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (!err) {
        this.onJourney({ channel: 'u-' + this.userId, data });
      }
    });
  };

  listJourney = (cb) => {
    let req = {
      partnerId: 0
    };
    this.api('listJourney', req, (err, data, success) => {
      if (success) {
        this.setState({ journeys: data || [] });
      }
      cb(err, data, success);
    });
  };

  resetCreateJourney = () => {
    this.resetApiState('createJourney');
    this.setState({
      files: [],
      icon: [],
      title: '',
      description: ''
    });
  };

  onJourney = ({ channel, data: msgData }) => {
    let data = { ...msgData };
    let userId = this.userId;
    if (channel !== 'u-' + userId) return this.log('wrong channel');
    if (!this.state.user?.isDoctor && data.userId !== this.userId) return false;

    let journeys = this.state.journeys;
    let index = journeys.findIndex((item) => item.id == data.id);
    if (data.removedDate) {
      if (index > -1) journeys.splice(index, 1);
    } else {
      if (index < 0) journeys.unshift(data);
      else journeys[index] = { ...journeys[index], ...data };
    }
    this.setState({ journeys });
    this.emit('journeyUpdate');
  };
}

const model = new TreatmentsTimelineModel();
export default model;
